import SEOMeta from "components/SEOMeta";
import { Link } from "react-router-dom";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";

export default function NotFound() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Erreur 404" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title="Page introuvable"
        description="La page que vous recherchez n'existe pas. Retournez à l'accueil pour continuer votre navigation."
      />
      <div>
        <h1>Page introuvable</h1>
        <p className="color-product-desc">La page demandée n'existe pas.</p>
        <Link to="/" className="btn">
          Retour à l'accueil
        </Link>
      </div>
    </>
  );
}
